module.exports = __webpack_public_path__ + "img/luyuanBg.302959ed.png";